import firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

const isConfigValid = !!(firebaseConfig.apiKey && firebaseConfig.messagingSenderId && firebaseConfig.appId);

if (isConfigValid && !firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const messaging = async () => {
  // In v8, isSupported is a static method on firebase.messaging
  const supported = await firebase.messaging.isSupported();
  return supported ? firebase.messaging() : null;
};

const fetchToken = async () => {
  if (!isConfigValid) {
    console.error("FCM: Firebase config is incomplete. Check your .env file.");
    return null;
  }

  try {
    const fcmMessaging = await messaging();
    if (fcmMessaging) {
      // v8 uses .getToken() directly on the messaging instance
      const token = await fcmMessaging.getToken({
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      });
      return token;
    }
  } catch (e) {
    console.error("🚀 ~ config.js: Error fetching token:", e);
    return null;
  }
};

// Helper for the foreground listener
const onMessageListener = async (callback) => {
  const fcmMessaging = await messaging();
  if (fcmMessaging) {
    return fcmMessaging.onMessage(callback);
  }
};

export { messaging, fetchToken, onMessageListener };
